<template>
  <el-col class="mb-2 p-0 px-0" :span="24">
    <div class="row m-0">

      <el-row :gutter="$vuetify.display.width > 1770 ? 10 : 10">



      <!-- session or unallocated sessions tab -->
      <el-col
        :span="$vuetify.display.width > 1770 ? 5 : $vuetify.display.width > 1293 ? 8 : 22"
        :class="'x-start order-1 mb-10'"
      >
        <el-radio-group
          v-model="sessionFilter"
          text-color="#ffff"
          fill="#234B49"
          :class="$vuetify.display.width < 750 ? 'width-100-p' : ''"
        >
          <el-radio-button
            class="start-period all-group-by text-center"
            label="1"
            :class="$vuetify.display.width < 750 ? 'width-50-p' : ''"
            :style="$vuetify.display.width < 630 ? 'max-width: 40%; padding-left: 10px; padding-right: 0px;' : ''"
          >
            Sessions
          </el-radio-button>
          <el-radio-button
            class="site-group-by text-center end-period"
            label="2"
            :class="$vuetify.display.width < 750 ? 'width-50-p' : ''"
            :style="$vuetify.display.width < 630 ? 'max-width: 60%; padding-left: 0px; padding-right: 0px;' : ''"
          >
            {{
              $vuetify.display.width < 500
                ? "Unallocated Ses."
                : "Unallocated Sessions"
            }}
          </el-radio-button>
        </el-radio-group>
      </el-col>

      <!-- Group by tabs -->
      <el-col
        :span="$vuetify.display.width > 1770 ? 8 : $vuetify.display.width > 1293 ? 14 : 24"
        :class="$vuetify.display.width > 1293 ? 'x-center order-2 mb-10' : 'x-start order-3 mb-10'"
      >
        <el-tooltip
             effect="light"
             placement="top"
             show-after="500"
             hide-after="300"
             >
             <template #content >
                <span v-if="sessionFilter == 1" :style="{fontSize: '12px', textAlign: 'left'}">Sessions Group By</span>
                <span v-if="sessionFilter == 2" :style="{fontSize: '12px', textAlign: 'left'}">Unallocated Sessions Group By</span>
            </template>
        <el-radio-group
          v-model="selectedGroupBy"
          text-color="#ffff"
          fill="#234B49"
          :class="$vuetify.display.width < 950 ? 'width-100-p mt-2' : ''"
        >
          <el-radio-button
            class="start-period all-group-by text-center"
            label="1"
            :class="
              $vuetify.display.width < 950
                ? sessionFilter == 2
                  ? 'width-20-p'
                  : 'width-25-p'
                : ''
            "
            :style="$vuetify.display.width < 630 ? sessionFilter == 2 ? 'max-width: 16%' : 'max-width: 16%' : ''"
          >
            All
          </el-radio-button>
          <el-radio-button
            class="start-period all-group-by text-center"
            label="2"
            :class="
              $vuetify.display.width < 950
                ? sessionFilter == 2
                  ? 'width-20-p'
                  : 'width-25-p'
                : ''
            "
            :style="$vuetify.display.width < 630 ? sessionFilter == 2 ? 'min-width: 16%' : 'min-width: 27.5%' : ''"
          >
            {{
              ($vuetify.display.width >= 1007 &&
                $vuetify.display.width <= 1155) ||
              ($vuetify.display.width > 750 && $vuetify.display.width <= 785) ||
              ($vuetify.display.width < 530 && sessionFilter == 2)
                ? "Region"
                : "By Region"
            }}
          </el-radio-button>
          <el-radio-button
            class="site-group-by text-center"
            label="3"
            :class="
              $vuetify.display.width < 950
                ? sessionFilter == 2
                  ? 'width-20-p'
                  : 'width-25-p'
                : ''
            "
            :style="$vuetify.display.width < 630 ? sessionFilter == 2 ? 'min-width: 22.6%' : 'min-width: 30%' : ''"
          >
            {{
              ($vuetify.display.width >= 1007 &&
                $vuetify.display.width <= 1155) ||
              ($vuetify.display.width > 750 && $vuetify.display.width <= 785) ||
              ($vuetify.display.width < 530 && sessionFilter == 2)
                ? "Charger"
                : "By Charger"
            }}
          </el-radio-button>
          <el-radio-button
            class="charger-group-by text-center end-period"
            label="4"
            :class="
              $vuetify.display.width < 950
                ? sessionFilter == 2
                  ? 'width-20-p'
                  : 'width-25-p'
                : ''
            "
            :style="$vuetify.display.width < 630 ? sessionFilter == 2 ? 'min-width: 16%' : 'min-width: 24%' : ''"
          >
            {{
              ($vuetify.display.width >= 1007 &&
                $vuetify.display.width <= 1155) ||
              ($vuetify.display.width > 750 && $vuetify.display.width <= 785) ||
              ($vuetify.display.width < 530 && sessionFilter == 2)
                ? "Site"
                : "By Site"
            }}
          </el-radio-button>
          <el-radio-button
            v-if="sessionFilter == 2"
            class="charger-group-by text-center end-period"
            label="5"
            :class="
              $vuetify.display.width < 950
                ? sessionFilter == 2
                  ? 'width-20-p'
                  : 'width-25-p'
                : ''
            "
            :style="$vuetify.display.width < 630 ? sessionFilter == 2 ? 'min-width: 16%' : 'min-width: 16%' : ''"
          >
            {{
              ($vuetify.display.width >= 1007 &&
                $vuetify.display.width <= 1155) ||
              ($vuetify.display.width > 750 && $vuetify.display.width <= 785) ||
              ($vuetify.display.width < 530 && sessionFilter == 2)
                ? "Error"
                : "By Error"
            }}
          </el-radio-button>
        </el-radio-group>
        </el-tooltip>
      </el-col>

      <!-- mix search bar when selectedGroupBy == 1 with select -->
      <el-col
            v-if="selectedGroupBy == 1"
                :span="$vuetify.display.width > 1770 ? 10 : 24"
                :class="$vuetify.display.width > 1770 ? 'x-start order-2 mb-10' : 'x-start order-4 mb-10'"
              >
              <el-input
                size="large"
                v-model="search"
                :placeholder="searchBytabs == 'site_name' ? 'Type to search by Site Name' : searchBytabs == 'charger_id' ? 'Type to search by Charger ID' : searchBytabs == 'port_id' ? 'Type to search by Port ID' : searchBytabs == 'postcode' ? 'Type to search by Postcode' : searchBytabs == 'description' ? 'Type to search by Description' : searchBytabs == 'usage' ? 'Type to search by Usage' : 'Type to search by site name, charger ID, port ...'"
                :prefix-icon="Search"
                class="mixedSearchBar"
                id="mixedSearchBar-input"
                clearable
                @clear="handleRefresh"
                >
                  <template #prepend >
                    <!-- search_by select -->
                    <el-tooltip
                      effect="light"
                      placement="top"
                      show-after="500"
                      hide-after="300"
                      >
                      <template #content >
                          <span :style="{fontSize: '12px', textAlign: 'left'}"> {{ "Select Search by" }} </span>
                      </template>

                      <el-select
                        v-model="searchBytabs"
                        placeholder="Select"
                        style="min-width: 117px; height: 40px;"
                        class="mixedSearchBar-select"
                      >
                        <template #label>
                          <span>Search by: </span>
                          <span style="font-weight: bold">{{ convertTabToTitleCase(searchBytabs) }}</span>
                        </template>
                        <el-option
                          v-for="(item, index) in search_by_dropdown[$store.state.auth.user != null && $store.state.auth.user.is_admin ? 'admin' : 'user'][sessionFilter == '1' ? 'session_search_by' : 'unallocated_session_search_by']"
                          :key="index"
                          :label="convertTabToTitleCase(item)"
                          :value="item"
                        />
                      </el-select>
                    </el-tooltip>
                  </template>

                  <template #append>
                    <!-- <el-button :icon="Search" /> -->
                    <el-button
                        @click.stop="handleRefresh"
                        class="newSearchButtonClass"
                      >
                      <svg v-if="$vuetify.display.width > 800" class="width-115 height-40">
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon"
                            ></use>
                          </svg>
                          <svg v-else class="width-59 height-40" >
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon-small"
                            ></use>
                          </svg>
                    </el-button>
                  </template>
              </el-input>
      </el-col>
      <!-- mix search bar -->

      <!-- mix search bar when selectedGroupBy != 1 without select -->
      <el-col
            v-else
                :span="$vuetify.display.width > 1770 ? 10 : 24"
                :class="$vuetify.display.width > 1770 ? 'x-start order-2 mb-10' : 'x-start order-4 mb-10'"
              >
              <el-input
                size="large"
                v-model="search"
                :placeholder="selectedGroupBy == 3 ? 'Type to search by Charger' : selectedGroupBy == 4 ? 'Type to search by Charging Site' : selectedGroupBy == 5 ? 'Type to search by Description' : selectedGroupBy == 2 ? 'Type to search by Region(State)' : 'Type to search by site name, charger ID, port ...'"
                :prefix-icon="Search"
                class="mixedSearchBar-2"
                id="mixedSearchBar-input-2"
                clearable
                @clear="handleRefresh"
                >
                  <template #append>
                    <!-- <el-button :icon="Search" /> -->
                    <el-button
                        @click.stop="handleRefresh"
                        class="newSearchButtonClass"
                      >
                      <svg v-if="$vuetify.display.width > 800" class="width-115 height-40">
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon"
                            ></use>
                          </svg>
                          <svg v-else class="width-59 height-40" >
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon-small"
                            ></use>
                          </svg>
                    </el-button>
                  </template>
              </el-input>
      </el-col>
      <!-- mix search bar -->

      <!-- download excel button -->
      <el-col
        :class="$vuetify.display.width > 1770 ? 'justify-content-end order-4' : $vuetify.display.width > 1293 ? 'justify-content-end order-3' : 'justify-content-end order-2 width-100-p'"
        :span="$vuetify.display.width > 1770 ? 1 : $vuetify.display.width > 1293 ? 1 : 1"
      >
        <el-dropdown trigger="hover" style="height: 40px;" @command="handleDownloadCommand">
          <el-button class="new-download-file-btn new-button-behavior">
            <svg class="width-40 height-40">
              <use href="@/assets/svg/newSvgIcon.svg#newDownloadFileIcon"></use>
            </svg>
          </el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="default">
                Default
              </el-dropdown-item>

              <!-- Available for Unallocated Sessions only -->
              <!-- <el-dropdown-item command="currentMP" v-if="sessionFilter == 2">
                Current MP
              </el-dropdown-item> -->
              <el-dropdown-item command="recent" v-if="sessionFilter == 2">
                Most Recent Upload
              </el-dropdown-item>
              <!-- Available for Unallocated Sessions only -->
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-col>

      <!-- reallocate button
       Only available for admin user > unallocated sessions table 
       and when search by register_id is applied -->
      <el-col 
        :class="$vuetify.display.width > 1770 ? 'justify-content-end order-4' : $vuetify.display.width > 1293 ? 'justify-content-end order-4' : 'justify-content-end order-4 width-100-p'"
        :span="$vuetify.display.width > 1770 ? 4 : $vuetify.display.width > 1293 ? 4 : 4"
         v-if="$store.state.auth.user != null && $store.state.auth.user.is_admin && sessionFilter == '2' && searchBytabs == 'register_id' && search != '' && sessionDataList.length > 0">
         <el-tooltip placement="top" effect="light">
           <template #content>
             Click button to reallocate sessions
           </template>
         <el-button
             @click.stop="handleReallocateSessions(filterProp.customer_id, search)"
             class="custom-filter-button-apply"
         >
             <svg class="width-111 height-40">
             <use href="@/assets/svg/newSvgIcon.svg#allocate_button"></use>
             </svg>
         </el-button>
        </el-tooltip>
      </el-col>
      </el-row>


    </div>
  </el-col>


<!-- delete button -->
  <!-- <el-col :span="24">
    <div class="row m-0">
      <el-col
        v-if="pendingSelectionList.length > 0"
        class="pr-0"
        :span="
          $vuetify.display.width >= 1300 && pendingSelectionList.length > 0
            ? 4
            : $vuetify.display.width >= 1300 && pendingSelectionList.length == 0
            ? 4
            : $vuetify.display.width >= 750 && pendingSelectionList.length > 0
            ? 4
            : $vuetify.display.width >= 750 && pendingSelectionList.length == 0
            ? 4
            : pendingSelectionList.length > 0
            ? 12
            : 24
        "
        :class="$vuetify.display.width < 750 ? 'x-center order-1' : ''"
      >
        <el-button
          @click.stop="pendingDelete"
          color="#0D3937"
          class="height-40 border-color-light width-100-p rounded-3 ml-1"
        >
          <svg class="stroke-icon width-20 height-20">
            <use
              href="@/assets/svg/icon-sprite.svg#stroke-filter-location"
            ></use>
          </svg>
          <span class="text-white pl-3"> Delete </span>
        </el-button>
      </el-col>
    </div>
  </el-col> -->
<!-- delete button -->

  <!-- table -->
  <el-col :span="24">
    <div
      class="ma-0"
      v-loading="loading"
      :element-loading-spinner="svg"
      element-loading-svg-view-box="-10, -10, 50, 50"
      element-loading-background="rgba(122, 122, 122, 0.8)"
    >

    <div class="custom-table-design">
      <el-table
        v-if="selectedGroupBy == '1'"
        :data="sessionDataList"
        :fit="true"
        height="650"
        class="my-2 width-100-p data-table"
        stripe
        scrollbar-always-on: false
        @selection-change="handleSelectionChange"
        @expand-change="handleCheckChargerDetailsAndSessionWithAbatementDetails"
      >
        <!-- <el-table-column
          v-if="
            sessionFilter == '2' &&
            $store.state.auth.user != null &&
            !$store.state.auth.user.is_auditor
          "
          type="selection"
          width="55"
        /> -->
        <el-table-column
          v-if="
            $store.state.auth.user != null && $store.state.auth.user.is_admin && $vuetify.display.width >= 500 && sessionFilter == '1' 
          "
          type="expand"
          class="coloo"
        >
          <template #default="scope">
            <!-- Additional abatement parameters details per session -->
            <el-table 
              v-if="sessionWithAbatementDetails[scope.row.internal_session_id]" 
              :data="[sessionWithAbatementDetails[scope.row.internal_session_id]]"
              :fit="true" 
              :height="100" 
              class="width-100-p data-table" 
              stripe 
              scrollbar-always-on: false
            >
              <el-table-column
                :label="'Energy Consumed'"
                :prop="'energy_consumed'"
                :width="$vuetify.display.width <= 2500 ? 180 : ''"
              >
                <template #default="sessionWithAbatementScope">
                  {{ sessionWithAbatementScope.row.energy_consumed == null ? "" : Number(sessionWithAbatementScope.row.energy_consumed).toLocaleString() }}
                </template>
              </el-table-column>
              <el-table-column
                :label="'Baseline (kg)'"
                :prop="'baseline'"
                :width="$vuetify.display.width <= 2500 ? 150 : ''"
              >
                <template #default="sessionWithAbatementScope">
                  {{ sessionWithAbatementScope.row.baseline == null ? "" : Number(sessionWithAbatementScope.row.baseline).toLocaleString() }}
                </template>
              </el-table-column>
              <el-table-column
                :label="'Project (kg)'"
                :prop="'project'"
                :width="$vuetify.display.width <= 2500 ? 150 : ''"
              >
                <template #default="sessionWithAbatementScope">
                  {{ sessionWithAbatementScope.row.project == null ? "" : Number(sessionWithAbatementScope.row.project).toLocaleString() }}
                </template>
              </el-table-column>
              <el-table-column
                :label="'Emission Intensity'"
                :prop="'emission_intensity'"
                :width="$vuetify.display.width <= 2500 ? 180 : ''"
              >
                <template #default="sessionWithAbatementScope">
                  {{ sessionWithAbatementScope.row.emission_intensity == null ? "" : Number(sessionWithAbatementScope.row.emission_intensity).toLocaleString() }}
                </template>
              </el-table-column>
              <el-table-column
                :label="'AFEC'"
                :prop="'afec'"
                :width="$vuetify.display.width <= 2500 ? 120 : ''"
              >
                <template #default="sessionWithAbatementScope">
                  {{ sessionWithAbatementScope.row.afec == null ? "" : Number(sessionWithAbatementScope.row.afec).toLocaleString() }}
                </template>
              </el-table-column>
              <el-table-column
                :label="'MPG'"
                :prop="'mpg'"
                :width="$vuetify.display.width <= 2500 ? 120 : ''"
              >
                <template #default="sessionWithAbatementScope">
                  {{ sessionWithAbatementScope.row.mpg == null ? "" : Number(sessionWithAbatementScope.row.mpg).toLocaleString() }}
                </template>
              </el-table-column>
              <el-table-column
                :label="'Private Fleet'"
                :prop="'private_fleet'"
                :width="$vuetify.display.width <= 2500 ? 120 : ''"
              >
                <template #default="sessionWithAbatementScope">
                  <svg v-if="sessionWithAbatementScope.row.private_fleet" 
                    id="booleanIconTrue" style="width: 20px; height: 24px; padding-top: 4px;">
                    <use href="@/assets/svg/newSvgIcon.svg#booleanIconTrue"></use>
                  </svg>
                  <svg v-else id="booleanIconFalse" style="width: 20px; height: 20px; height: 24px; padding-top: 4px;">
                    <use href="@/assets/svg/newSvgIcon.svg#booleanIconFalse"></use>
                  </svg>
                </template>
              </el-table-column>
              <el-table-column
                :label="'Improvement Rate'"
                :prop="'ir'"
                :width="$vuetify.display.width <= 2500 ? 180 : ''"
              >
                <template #default="sessionWithAbatementScope">
                  {{ sessionWithAbatementScope.row.ir == null ? "" : Number(sessionWithAbatementScope.row.ir).toLocaleString() }}
                </template>
              </el-table-column>
              <el-table-column
                :label="'Onsite Renewable Model'"
                :prop="'onsite_renewable'"
                :width="$vuetify.display.width <= 2500 ? 220 : ''"
              >
                <template #default="sessionWithAbatementScope">
                  {{ sessionWithAbatementScope.row.onsite_renewable == null ? "" : sessionWithAbatementScope.row.onsite_renewable.replaceAll('_', ' ')}}
                </template>
              </el-table-column>
              <el-table-column
                :label="'Battery EI'"
                :prop="'battery_ei'"
                :width="$vuetify.display.width <= 2500 ? 120 : ''"
              >
                <template #default="sessionWithAbatementScope">
                  {{ sessionWithAbatementScope.row.battery_ei == null ? "" : Number(sessionWithAbatementScope.row.battery_ei).toLocaleString() }}
                </template>
              </el-table-column>
              <el-table-column
                :label="'Battery to EV'"
                :prop="'battery_to_ev'"
                :width="$vuetify.display.width <= 2500 ? 150 : ''"
              >
                <template #default="sessionWithAbatementScope">
                  {{ sessionWithAbatementScope.row.battery_to_ev == null ? "" : Number(sessionWithAbatementScope.row.battery_to_ev).toLocaleString() }}
                </template>
              </el-table-column>
              <el-table-column
                :label="'Solar to EV'"
                :prop="'solar_to_ev'"
                :width="$vuetify.display.width <= 2500 ? 150 : ''"
              >
                <template #default="sessionWithAbatementScope">
                  {{ sessionWithAbatementScope.row.solar_to_ev == null ? "" : Number(sessionWithAbatementScope.row.solar_to_ev).toLocaleString() }}
                </template>
              </el-table-column>
              <el-table-column
                :label="'Battary to Grid'"
                :prop="'battery_to_grid_kgco2'"
                :width="$vuetify.display.width <= 2500 ? 220 : ''"
              >
                <template #default="sessionWithAbatementScope">
                  {{ sessionWithAbatementScope.row.battery_to_grid_kgco2 == null ? "" : Number(sessionWithAbatementScope.row.battery_to_grid_kgco2).toLocaleString() }}
                </template>
              </el-table-column>
            </el-table>
            <!-- Additional charger details per session -->
            <el-table 
              v-if="chargerDetails[scope.row.charger_id]" 
              :data="[chargerDetails[scope.row.charger_id]]"
              :fit="true" 
              :height="80" 
              class="width-100-p data-table" 
              stripe 
              scrollbar-always-on: false
            >
              <el-table-column
                :label="'Motion Charger ID'"
                :prop="'charger_id'"
              />
              <el-table-column
                :label="'Install Date'"
                :prop="'install_date'"
              >
                <template #default="chargerScope">
                  {{ chargerScope.row.install_date ? chargerScope.row.install_date.replace('T', ' ') : '' }}
                </template>
              </el-table-column>
              <el-table-column
                :label="'Operational Date'"
                :prop="'operational_date'"
              >
                <template #default="chargerScope">
                  {{ chargerScope.row.operational_date ? chargerScope.row.operational_date.replace('T', ' ') : '' }}
                </template>
              </el-table-column>
              <el-table-column
                :label="'Decommissioning Date'"
                :prop="'decommissioning_date'"
              >
                <template #default="chargerScope">
                  {{ chargerScope.row.decommissioning_date ? chargerScope.row.decommissioning_date.replace('T', ' ') : '' }}
                </template>
              </el-table-column>
              <el-table-column
                :label="'Active Until'"
                :prop="'active_until'"
              >
                <template #default="chargerScope">
                  {{ chargerScope.row.active_until ? chargerScope.row.active_until.replace('T', ' ') : '' }}
                </template>
              </el-table-column>

              <el-table-column
                :label="'MP Name'"
                :prop="'mp_name'"
              >
                <template #default>
                  {{ scope.row.mp_name ? scope.row.mp_name.replaceAll('_', ' ').toUpperCase() : '' }}
                </template>
              </el-table-column>
              <el-table-column
                :label="'MP Status'"
                :prop="'mp_status'"
              >
                <template #default>
                  {{ scope.row.mp_status ? scope.row.mp_status.replaceAll('_', ' ').toUpperCase() : '' }}
                </template>
              </el-table-column>
            </el-table>
            <div v-else class="pa-4 text-center">
              <span>Loading charger and abatement parameters details...</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="
            $store.state.auth.user != null && $store.state.auth.user.is_admin && sessionFilter == '2'
          "
          :label="'Register ID'"
          :prop="'register_id'"
          :width="$vuetify.display.width <= 1900 ? 200 : ''"
          sortable
        />
        <el-table-column
          :label="'Site Name'"
          :prop="'site_title'"
          :width="$vuetify.display.width <= 1900 ? 200 : ''"
          sortable
        />
        <el-table-column
          v-if="
            $store.state.auth.user != null && $store.state.auth.user.is_admin
          "
          :label="'Customer'"
          :prop="'customer'"
          :width="$vuetify.display.width <= 1900 ? 200 : ''"
          sortable
        />
        <el-table-column
          :label="'Postcode'"
          :prop="'postcode'"
          :width="$vuetify.display.width <= 1900 ? 170 : ''"
          sortable
        />
        <el-table-column
          v-if="sessionFilter == '1'"
          :label="'Elec Region'"
          :prop="'elec_region'"
          :width="$vuetify.display.width <= 1900 ? 200 : ''"
          sortable
        />
        <el-table-column
          :label="'Charger ID'"
          :prop="sessionFilter == '2' ? 'charger_id' : 'charger_name'"
          :width="$vuetify.display.width <= 1900 ? 200 : ''"
          sortable
        />
        <el-table-column
          :label="'Charger Capacity (kW)'"
          :prop="'charger_capacity_kW'"
          :width="$vuetify.display.width <= 1900 ? 200 : ''"
          sortable
        >
        <template #default="scope">
          {{
            scope.row.charger_capacity_kW == null
              ? ""
              : Number(scope.row.charger_capacity_kW).toLocaleString()
          }}
        </template>
      </el-table-column>
        <el-table-column
          :label="'Port ID'"
          :prop="'port'"
          :width="$vuetify.display.width <= 1900 ? 150 : ''"
          sortable
        />
        <el-table-column
          :label="'Start Time'"
          :prop="'start_time'"
          :width="$vuetify.display.width <= 1900 ? 180 : ''"
          sortable
        >
          <template #default="scope">
            {{
              scope.row.start_time == null
                ? ""
                : (scope.row.start_time).replace("T", " ")
            }}
          </template>
        </el-table-column>
        <el-table-column
          :label="'End Time'"
          :prop="'end_time'"
          :width="$vuetify.display.width <= 1900 ? 180 : ''"
          sortable
        >
          <template #default="scope">
            {{
              scope.row.end_time == null
                ? ""
                : (scope.row.end_time).replace("T", " ")
            }}
          </template>
        </el-table-column>
        <el-table-column
          :label="'Usage (kWh)'"
          :prop="'usage_kWh'"
          :width="$vuetify.display.width <= 1900 ? 150 : ''"
          sortable
        >
          <template #default="scope">
            {{
              scope.row.usage_kWh == null
                ? ""
                : Number(scope.row.usage_kWh).toLocaleString()
            }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="sessionFilter == '1'"
          :label="'Abatement (kg)'"
          :prop="'abatement_kg'"
          :width="$vuetify.display.width <= 1900 ? 150 : ''"
          sortable
          >
          <template #default="scope">
            {{
              scope.row.abatement_kg === 'Pending'
                ? "Pending"
                : Number(scope.row.abatement_kg).toLocaleString()
            }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="sessionFilter == '2' && selectedGroupBy == '1'"
          :label="'Power (kW)'"
          :prop="'avg_power'"
          :width="$vuetify.display.width <= 1900 ? 200 : ''"
          sortable
          >
          <template #default="scope">
            {{
              scope.row.avg_power == null
                ? ""
                : Number(scope.row.avg_power).toLocaleString()
            }}
          </template>
        </el-table-column>

        <el-table-column
          v-if="sessionFilter == '2'"
          :label="'Description'"
          :prop="'description'"
          :width="$vuetify.display.width <= 1900 ? 500 : ''"
        />
      </el-table>


      <el-table
        v-else
        :data="sessionDataGroupBy"
        :fit="true"
        height="650"
        class="my-2 width-100-p data-table"
        stripe
        scrollbar-always-on: false
      >
      <el-table-column
        v-if="sessionFilter == '2'"
          :label="
            selectedGroupBy == '2'
              ? 'Elec Region'
              : selectedGroupBy == '3'
              ? 'Charger ID'
              : selectedGroupBy == '4'
              ? 'Site Name'
              : 'Description'
          "
          :prop="'group_by'"
          :width="$vuetify.display.width <= 750 ? 200 : ''"
          sortable
        />
      <el-table-column
        v-if="sessionFilter == '1' && selectedGroupBy == '3'"
          :label="'Site Name'"
          :prop="'site_name'"
          :width="$vuetify.display.width <= 750 ? 200 : ''"
          sortable
        />
        <el-table-column
          v-if="sessionFilter == '1'"
          :label="
            selectedGroupBy == '2'
              ? 'Elec Region'
              : selectedGroupBy == '3'
              ? 'Charger ID'
              : selectedGroupBy == '4'
              ? 'Site Name'
              : 'Description'
          "
          :prop="            
            selectedGroupBy == '2'
              ? 'group_by'
              : selectedGroupBy == '3'
              ? 'charger_name'
              : selectedGroupBy == '4'
              ? 'site_name'
              : 'description'"
          :width="$vuetify.display.width <= 750 ? 200 : ''"
          sortable
        />
        <el-table-column
          :label="'Number of Sessions'"
          :prop="'count_session'"
          :width="$vuetify.display.width <= 750 ? 170 : ''"
          sortable
        >
          <template #default="scope">
            {{
              scope.row.count_session == null
                ? ""
                : Number(scope.row.count_session).toLocaleString()
            }}
          </template>
        </el-table-column>
        <el-table-column
          :label="'Usage (MWh)'"
          :prop="'sum_usage'"
          :width="$vuetify.display.width <= 750 ? 200 : ''"
          sortable
        >
          <template #default="scope">
            {{
              scope.row.sum_usage == null
                ? ""
                : Number(scope.row.sum_usage).toLocaleString()
            }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="sessionFilter == '2' && selectedGroupBy == '1'"
          :label="'Power (kW)'"
          :prop="'avg_power'"
          :width="$vuetify.display.width <= 750 ? 150 : ''"
          sortable
          >
          <template #default="scope">
            {{
              scope.row.avg_power == null
                ? ""
                : Number(scope.row.avg_power).toLocaleString()
            }}
          </template>
        </el-table-column>

        <!-- operations -->
        <el-table-column
          v-if="showSessionActionsColumn"
          :label="'Actions'"
          :prop="'operations'"
          align="center"
          width="250"
        >
          <template #default="scope">
            <el-tooltip
              v-if="sessionFilter == '1' && (scope.row.site_name || scope.row.charger_name)"
              placement="top"
              effect="light"
            >
              <template #content>Run Abatement</template>
              <el-button
                v-if="scope.row.site_name || scope.row.charger_name"
                @click.stop="handleAbatementCalcRow(scope.row)"
                size="small"
                class="height-25 rounded-2 m-0 ml-2"
                color="#DDF0AC"
                style="width: 25px; height: 25px; padding: 0px; align-items: center;"
              >
                  <svg style="width: 24px; height: 24px;">
                      <use href="@/assets/svg/newSvgIcon.svg#tableOperationCalculation"></use>
                  </svg>
              </el-button>
            </el-tooltip>
            <el-tooltip
              v-if="isAdminUser && selectedGroupBy == '4' && siteNameForReset(scope.row)"
              placement="top"
              effect="light"
            >
              <template #content>Reset elec region</template>
              <el-button
                @click.stop="handleResetElecRegion(scope.row)"
                size="small"
                :disabled="isResettingElecRegionRow(scope.row)"
                class="height-25 rounded-2 m-0 ml-2"
                color="#DDF0AC"
                style="width: 25px; height: 25px; padding: 0px; align-items: center;"
              >
                  <svg style="width: 24px; height: 24px;">
                      <use href="@/assets/svg/newSvgIcon.svg#tableOperationReset"></use>
                  </svg>
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="custom-pagination" v-if="$vuetify.display.width >= 700">
        <el-row
          v-if="selectedGroupBy == '1'"
          class="row-bg"
          justify="space-between"
        >
          <el-col
            :span="5"
            class="d-flex justify-content-start align-items-center"
          >
            <el-select
              v-model="perPageCount"
              placeholder="Select"
              size="small"
              style="width: 70px"
            >
              <el-option label="10" :value="'10'" />
              <el-option label="25" :value="'25'" />
              <el-option label="50" :value="'50'" />
              <el-option label="100" :value="'100'" />
              <el-option label="500" :value="'500'" />
              <el-option label="1k" :value="'1000'" />
            </el-select>
          </el-col>
          <el-col
            :span="8"
            class="d-flex align-items-center justify-content-center"
          >
            <el-pagination
              small
              background
              layout="prev, pager, next"
              :total="total_items"
              v-model:page-size="page_size"
              v-model:current-page="current_page"
              @current-change="changePage"
              class="my-4"
            />
          </el-col>
          <el-col :span="5" class="d-flex justify-content-end align-items-center">
            <span class="text-white">
              {{ ((current_page - 1) * perPageCount + 1).toLocaleString() }}-{{
                current_page * perPageCount > total_items
                  ? total_items.toLocaleString()
                  : (current_page * perPageCount).toLocaleString()
              }}
              of {{ total_items.toLocaleString() }}
            </span>
          </el-col>
        </el-row>
      </div>

      <div class="custom-pagination" v-if="$vuetify.display.width < 700">
        <el-row
          v-if="selectedGroupBy == '1'"
          class="row-bg"
          justify="space-between"
        >
        <el-col
            :span="24"
            class="d-flex align-items-center justify-content-center"
          >
            <el-pagination
              small
              background
              layout="prev, pager, next"
              :total="total_items"
              v-model:page-size="page_size"
              v-model:current-page="current_page"
              @current-change="changePage"
              class="my-4"
            />
          </el-col>
          <el-col
            :span="10"
            class="d-flex justify-content-end align-items-center"
          >
            <el-select
              v-model="perPageCount"
              placeholder="Select"
              size="small"
              style="width: 70px"
            >
              <el-option label="10" :value="'10'" />
              <el-option label="25" :value="'25'" />
              <el-option label="50" :value="'50'" />
              <el-option label="100" :value="'100'" />
              <el-option label="500" :value="'500'" />
              <el-option label="1k" :value="'1000'" />
            </el-select>
          </el-col>
          <el-col :span="10" class="d-flex justify-content-start align-items-center">
            <span class="text-white">
              {{ ((current_page - 1) * perPageCount + 1).toLocaleString() }}-{{
                 current_page * perPageCount > total_items
                   ? total_items.toLocaleString()
                   : (current_page * perPageCount).toLocaleString()
               }}
               of {{ total_items.toLocaleString() }}
            </span>
          </el-col>
        </el-row>
      </div>
    </div>
  </el-col>
</template>

<script>
import UserService from "../../../services/user.service";
import {convertToTitleCase, shorterLabel} from "../../dashboard/common/common-tools"
import { ElMessageBox } from "element-plus";
import { useToast } from "vue-toastification";
// import XLSX from "xlsx";
// import moment from "moment";
import { exportToExcel } from "../common/exportExcel";
import { addTaskIdtoSessionStorage, createCeleryTaskPoller } from "../common/pollingCeleryTask";

export default {
  props: {
    filterProp: {
      type: Object,
      default: null,
    },
  },
  components: {},
  emits: [
    "cardLoadingChange",
    "changeTab",
    "filterHandle",
    "selectedTableFromChild",
    "sessionDataToParent",
    "tableAction",
    "cacheUpdatedAt",
  ],
  data() {
    return {
      selectedGroupBy: "1",
      searchBytabs: "site_name",
      sessionFilter: "1",
      sessionDataList: [],
      sessionDataGroupBy: [],
      pendingSelectionList: [],
      search: "",
      loading: false,
      current_page: 1,
      page_size: 50,
      total_items: 100,
      perPageCount: 50,
      excelDataList: [],
      total: {
        total_sessions: 0,
        total_usage: 0,
      },
      // Add controller for session data request cancellation
      sessionController: null,
      sessionCardController: null,
      sessionCardRequestId: 0,
      pendingCardController: null,
      pendingCardRequestId: 0,
      groupByCardController: null,
      groupByCardRequestId: 0,
      groupByTotals: {
        total_count: 0,
        total_usage: 0,
      },

      search_by_dropdown: {
        admin: {
          session_search_by: ['site_name', 'charger_id', 'port_id', 'postcode', 'usage'],
          unallocated_session_search_by: ['site_name', 'register_id', 'charger_id', 'port_id', 'postcode', 'description', 'usage'],
        },
        user: {
          session_search_by: ['site_name', 'charger_id', 'port_id', 'postcode', 'usage'],
          unallocated_session_search_by: ['site_name', 'charger_id', 'port_id', 'postcode', 'description', 'usage'],
        }
      },

      hasCustomerFilter: false,
      sessionPoller: null, // Store reference to the session poller
      resettingElecRegionBySite: {},

      chargerDetails: {}, // Store charger details by charger_id
      sessionWithAbatementDetails: {}, // Store session with abatement parameters by internal_session_id
    };
  },
  computed: {
    isAdminUser() {
      return (
        this.$store.state.auth.user != null &&
        this.$store.state.auth.user.is_admin &&
        !this.$store.state.auth.user.is_auditor
      );
    },
    hasSelectedCustomer() {
      const id = this.filterProp?.customer_id;
      return id != null && id !== "";
    },
    showSessionActionsColumn() {
      if (!this.isAdminUser) return false;
      const allocatedChargerOrSite =
        this.sessionFilter == "1" &&
        (this.selectedGroupBy == "3" || this.selectedGroupBy == "4") &&
        this.hasCustomerFilter == true;
      const siteGroupReset =
        this.selectedGroupBy == "4" &&
        this.hasSelectedCustomer &&
        (this.sessionFilter == "1" || this.sessionFilter == "2");
      return allocatedChargerOrSite || siteGroupReset;
    },
  },
  watch: {
    // watch when search by tabs changes
    searchBytabs: function() {
      if (this.sessionFilter == 1) {
          // fetch for sessions
          this.fetchSessionData(this.current_page, this.search, true);
        } else {
        // fetch for unallocated sessions
        this.fetchPendingData(this.current_page, this.search, true);
        }
    },

    filterProp: {
      handler: function () {
        // console.log(newValue);
        //this.fetchSessionData(this.current_page, this.search);
        this.handleRefresh();
      },
      deep: true,
    },
    selectedGroupBy: function (newVal) {
      this.cancelSessionRequest();
      if (newVal == 1) {
        this.$emit("sessionDataToParent", {
          sessionDataList: [],
          selectedGroupBy: 1,
          totalCount: 0,
        });
        if (this.sessionFilter == 1)
          this.fetchSessionData(this.current_page, this.search, true);
        else this.fetchPendingData(this.current_page, this.search, true);
      } else {
        this.current_page = 1;
        this.fetchSessionGroupBy(this.search, true);
      }
      this.$emit("filterHandle", this.filter);
    },
    sessionFilter: function (newVal) {
      this.cancelSessionRequest();
      this.current_page = 1;
      this.page_size = 50;
      this.perPageCount = 50;
      this.selectedGroupBy = "1";
      if (newVal == 1) {
        this.$emit("selectedTableFromChild", "sessions");
        this.fetchSessionData(this.current_page, this.search, true);
      } else if (newVal == 2) {
        this.$emit("selectedTableFromChild", "unallocatedSessions");
        this.fetchPendingData(this.current_page, this.search, true);
      }
    },
    current_page: function (newVal) {
      this.current_page = newVal;
      if (this.selectedGroupBy != 1) return;
      if (this.sessionFilter == 1) {
        this.fetchSessionData(this.current_page, this.search);
      } else if (this.sessionFilter == 2) {
        this.fetchPendingData(this.current_page, this.search);
      }
    },
    perPageCount: function (newVal) {
      this.current_page = 1;
      this.page_size = parseInt(newVal);
      if (this.selectedGroupBy != 1) return;
      if (this.sessionFilter == 1) {
        this.fetchSessionData(this.current_page, this.search);
      } else if (this.sessionFilter == 2) {
        this.fetchPendingData(this.current_page, this.search);
      }
    },

    // check if customer filter is applied
    "filterProp.customer_id": {
      handler: function (value, oldValue) {
        this.hasCustomerFilter = value != null && value != "" && value != oldValue;
      },
      deep: true,
    },
  },
  mounted() {
    // this.fetchSessionData(this.current_page, this.search); // new custom filter will be applied to fetch Currnet Period data
    // this.startSessionTask();
    // setTimeout(() => {
    //   this.finishSessionTask();
    // }, 5000);
  },
  methods: {
    handleAbatementCalcRow(row) {
      // By site: site_name only. By charger: site_name + charger_name.
      // charger_name without site_name matches 0 sessions on the calculator.
      const isSiteLevel = this.selectedGroupBy == "4";
      const data = {
        customer_id: this.filterProp.customer_id,
        status: this.filterProp.status,
        charger_name: isSiteLevel ? null : (row.charger_name || null),
        site_name: row.site_name || null,
        mp_id: this.filterProp.mp_id || null,
      };
      this.$emit("tableAction", { data: data, kind: "showAbatementCalDetails" });
    },

    siteNameForReset(row) {
      if (!row) return "";
      const name = row.site_name || row.group_by;
      return name == null ? "" : String(name).trim();
    },

    isResettingElecRegionRow(row) {
      const siteName = this.siteNameForReset(row);
      return !!(siteName && this.resettingElecRegionBySite[siteName]);
    },

    formatElecRegionLabel(value) {
      return value == null || value === "" ? "" : String(value);
    },

    async handleResetElecRegion(row) {
      if (this.selectedGroupBy != "4") return;
      const siteName = this.siteNameForReset(row);
      const customerId = this.filterProp?.customer_id;
      if (!this.isAdminUser) {
        useToast().error("Admin only.", {
          icon: "fa fa-times",
          position: "bottom-right",
          timeout: 3000,
        });
        return;
      }
      if (!customerId) {
        useToast().error("Customer filter is not applied.", {
          icon: "fa fa-times",
          position: "bottom-right",
          timeout: 3000,
        });
        return;
      }
      if (!siteName) {
        useToast().error("Site name is required.", {
          icon: "fa fa-times",
          position: "bottom-right",
          timeout: 3000,
        });
        return;
      }
      if (this.resettingElecRegionBySite[siteName]) return;

      this.resettingElecRegionBySite[siteName] = true;
      try {
        await ElMessageBox.confirm(
          "This overwrites the site's electricity region from location data.",
          "Reset elec region",
          {
            confirmButtonText: "Reset",
            cancelButtonText: "Cancel",
            type: "warning",
          }
        );
        const response = await UserService.resetUkElecRegion(customerId, siteName);
        const payload = response?.data?.data && response.data.old_elec_region === undefined
          ? response.data.data
          : (response?.data || {});
        const oldRegion = this.formatElecRegionLabel(payload.old_elec_region);
        const newRegion = this.formatElecRegionLabel(payload.new_elec_region);
        useToast().success(`elec_region: ${oldRegion} → ${newRegion}`, {
          icon: "fa fa-check",
          position: "bottom-right",
          timeout: 4000,
        });
        if (payload.new_elec_region == null || payload.new_elec_region === "") {
          useToast().warning("The electricity region could not be resolved from location data.", {
            icon: "fa fa-exclamation-triangle",
            position: "bottom-right",
            timeout: 5000,
          });
        }
      } catch (error) {
        if (error === "cancel" || error === "close" || error?.action === "cancel") return;
        if (error?.response?.status == 401) {
          this.$router.push({ path: "/" });
          return;
        }
        const status = error?.response?.status;
        let message = error?.response?.data?.message || error?.message || "Failed to reset elec region.";
        if (status === 403) message = "Admin only.";
        else if (status === 404) message = "Charging site not found.";
        else if (status === 400) message = error?.response?.data?.message || "Invalid request.";
        useToast().error(message, {
          icon: "fa fa-times",
          position: "bottom-right",
          timeout: 4000,
        });
      } finally {
        this.resettingElecRegionBySite[siteName] = false;
      }
    },

    /**
     * Apply reallocate action for unallocated sessions
     * @param {string} search - The search term
     */
    // send delete request
    handleReallocateSessions(customer_id, register_id) {
      console.log(`apply reallocate for customer_id: ${customer_id} and register_id: ${register_id}`);
      if (!customer_id || customer_id == null || customer_id == "") {
        this.$message.error("Customer filter is not applied, please apply customer filter to reallocate");
        return;
      }
      if (!register_id || register_id == null || register_id == "") {
        this.$message.error("Register ID is not applied, please apply register ID to reallocate");
        return;
      }

      let MessageBox = `<span class="moderat-meGreen-bold">Do you want to proceed with reallocating sessions: <br> Customer: ${customer_id} <br> with Register ID: ${register_id} <br> This action cannot be undone!</span>`;

      return ElMessageBox.confirm(
        MessageBox,
        "Confirm Reallocate",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "Cancel",
          type: "confirm",
          dangerouslyUseHTMLString: true,
        }
      ).then(() => {
        this.applyReallocate(customer_id, register_id);
      }
      ).catch(() => {
        console.log("Reallocate cancelled");
      });
    },


    async applyReallocate(customer_id, register_id) {
      const response = await UserService.ReallocateUnallocatedSessions(customer_id, register_id);
      if (!response.data || !response.data.code == 1000) {
        this.$message.error(response.data.message);
        return;
      }

      this.$message.success(response.data.message + "It will take some time to reallocate, please check task result in history log later.");
        setTimeout(() => {
        this.search = "";
        this.fetchPendingData(this.current_page, this.search);
      }, 2000);
    },

    handleCheckChargerDetailsAndSessionWithAbatementDetails(row, expandedRows) {
      console.log("handleCheckChargerDetailsAndSessionWithAbatementDetails", row, expandedRows);
      this.handleCheckChargerDetails(row, expandedRows);
      this.handleCheckSessionWithAbatementDetails(row, expandedRows);
    },

    handleCheckChargerDetails(row, expandedRows) {
      console.log("handleCheckChargerDetails", row, expandedRows);
      // Check if the row is in the expandedRows array (meaning it was expanded)
      const isExpanded = expandedRows.some(expandedRow => expandedRow.charger_id === row.charger_id);
      if (isExpanded && row.charger_id) {
        // Only fetch if not already cached
        if (!this.chargerDetails[row.charger_id]) {
          this.getChargerDetails(row.charger_id, row.customer_id);
        }
      }
    },

    handleCheckSessionWithAbatementDetails(row, expandedRows) {
      console.log("handleCheckSessionWithAbatementDetails", row, expandedRows);
      // Check if the row is in the expandedRows array (meaning it was expanded)
      const isExpanded = expandedRows.some(expandedRow => expandedRow.internal_session_id === row.internal_session_id);
      if (isExpanded && row.internal_session_id) {
        // Only fetch if not already cached
        if (!this.sessionWithAbatementDetails[row.internal_session_id]) {
          this.fetchSessionWithAbatementData(row.internal_session_id, row.customer_id);
        }
      }
    },

    async getChargerDetails(charger_id, customer_id) {
      let request = {
        customer_id: customer_id,
        search: charger_id.toString(),
        search_by: 'unique_charger_id',
        start_date: this.filterProp.startDate,
        end_date: this.filterProp.endDate,
      }
      const response = await UserService.GetChargerList(request);
      if (!response.data || !response.data.chargers || response.data.chargers.length == 0) {
        console.log("No charger details found");
        this.chargerDetails[charger_id] = null;
        return null;
      }
      this.chargerDetails[charger_id] = response.data.chargers[0];
    },

    async fetchSessionWithAbatementData(internal_session_id, customer_id) {
      let request = {
        command: "fetch",
        customer_id: customer_id,
        internal_session_id: internal_session_id,
        mp_id: this.filterProp.mp_id,
      }
      const response = await UserService.GetSessionWithAbatement(request);  
      if (!response.data) {
        console.log("No session with abatement details found");
        this.sessionWithAbatementDetails[internal_session_id] = null;
        return null;
      }
      this.sessionWithAbatementDetails[internal_session_id] = response.data.sessionsWithAbatement[0];
    },


    // table tab logic
    /**
     * When change tab Session or Unallocated Session:
     * sessionFilter: 1 - Sessions, 2 - Unallocated Sessions
     *
     * When change tab All, By Region, By Charger, By Site, By Error:
     * selectedGroupBy: 1 - All, 2 - By Region, 3 - By Charger, 4 - By Site, 5 - By Error
     *
     * When sessionFilter is 1 and selectedGroupBy is 1:
     * - call function fetchSessionData to fetch session data
     * - endpoint: /api/session-list?page=
     *
     * When sessionFilter is 2 and selectedGroupBy is 1:
     * - call function fetchPendingData to fetch pending data
     * - endpoint: /api/session-log-list?page=
     *
     *
     * When sessionFilter is 2 and selectedGroupBy is 2, 3, 4, 5:
     * - call function fetchSessionGroupBy to fetch session data grouped by
     * - endpoint: /api/dashboard-session-group-by
     */

     convertTabToTitleCase(str){
      return convertToTitleCase(str);
     },

     convertShorterLabel(label, setLength, setMinLength, addOnLabel="") {
      return shorterLabel(label, setLength, setMinLength, addOnLabel);
    },
// session search by



    buildSessionListFilter(search) {
      return {
        start_date: this.filterProp.startDate,
        end_date: this.filterProp.endDate,
        customer_id: this.filterProp.customer_id,
        charger_name: this.filterProp.charger_name,
        search: search,
        search_by: this.searchBytabs,
        elec_region: this.filterProp.elec_region || "",
        country: this.filterProp.country || "",
        mp_id: this.filterProp.mp_id ?? null,
      };
    },

  /**
   * Fetches paginated session table rows and card totals independently.
   * Table endpoint: api/session-list-table?page=1&page_size=50
   * Card endpoint: api/session-list-card
   */
    async fetchSessionData(page, search, fetchCard = false) {
      let filter = this.buildSessionListFilter(search);
      this.loading = true;
      if (fetchCard) {
        this.fetchSessionCardData({ ...filter });
      }
      
      // Get both response and controller from the service
      const { response, controller } = UserService.GetSessionListTable(filter, page, this.page_size);
      this.sessionController = controller;
      await response
        .then(
          (response) => {
            if(!response.data || !response.data.sessions){
              this.sessionDataList = [];
              console.log("Session response is invalid");
              return;
            }
            this.sessionDataList = response.data.sessions;
            this.current_page = Number(response.data.page || page || 1);
            this.page_size = Number(response.data.page_size || this.page_size);
          },
          (error) => {
            this.loading = false;
            console.log(error.message);
            // Handle AbortError (request was cancelled)
            if (error.code === 'ERR_CANCELED') {
              console.log('Session data request was cancelled');
              return;
            }
            if (error.response && error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error.message);
        })
        .finally(() => {
          this.loading = false;
          this.sessionController = null; // Clear controller reference
        });
    },

    async fetchSessionCardData(filter) {
      this.sessionCardRequestId += 1;
      const requestId = this.sessionCardRequestId;
      this.cancelSessionCardRequest();
      this.$emit("cardLoadingChange", true);

      const { response, controller } = UserService.GetSessionListCard(filter);
      this.sessionCardController = controller;

      await response
        .then(
          (response) => {
            if (requestId !== this.sessionCardRequestId) return;
            if (!response.data) {
              this.total.total_sessions = 0;
              this.total.total_usage = 0;
              this.total_items = 0;
              this.$emit("cacheUpdatedAt", "");
              this.$emit("changeTab", this.total);
              console.log("Session card response is invalid");
              return;
            }
            this.total.total_sessions = response.data.total_sessions || 0;
            this.total.total_usage = response.data.total_usage || 0;
            this.total_items = this.total.total_sessions;
            this.cacheUpdatedAtFromResponse(response);
            this.$emit("changeTab", this.total);
          },
          (error) => {
            if (error.code === 'ERR_CANCELED') {
              console.log('Session card request was cancelled');
              return;
            }
            console.log(error.message);
            if (error.response && error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        )
        .catch((error) => {
          if (error.code === 'ERR_CANCELED') return;
          console.log(error.message);
        })
        .finally(() => {
          if (requestId === this.sessionCardRequestId) {
            this.$emit("cardLoadingChange", false);
            this.sessionCardController = null;
          }
        });
    },

    /**
     * Cancels the current session data request if one is in progress
     */
    cancelSessionRequest() {
      console.log("cancelSessionRequest");
      if (this.sessionController) {
        this.sessionController.abort();
        this.sessionController = null;
        this.loading = false;
      }
      this.cancelSessionCardRequest();
      this.cancelPendingCardRequest();
      this.cancelGroupByCardRequest();
    },

    cancelSessionCardRequest() {
      if (this.sessionCardController) {
        this.sessionCardController.abort();
        this.sessionCardController = null;
        this.$emit("cardLoadingChange", false);
      }
    },

    cancelPendingCardRequest() {
      if (this.pendingCardController) {
        this.pendingCardController.abort();
        this.pendingCardController = null;
        this.$emit("cardLoadingChange", false);
      }
    },

    cancelGroupByCardRequest() {
      if (this.groupByCardController) {
        this.groupByCardController.abort();
        this.groupByCardController = null;
        this.$emit("cardLoadingChange", false);
      }
    },

    buildGroupByFilter(search) {
      return {
        start_date: this.filterProp.startDate,
        end_date: this.filterProp.endDate,
        group_by: this.selectedGroupBy,
        kind: this.sessionFilter,
        customer_id: this.filterProp.customer_id,
        charger_name: this.filterProp.charger_name,
        search: search,
        elec_region: this.filterProp.elec_region || "",
        country: this.filterProp.country || "",
        mp_id: this.filterProp.mp_id ?? null,
      };
    },

    emitSessionGroupByToParent(sessionDataList) {
      this.$emit("sessionDataToParent", {
        sessionDataList,
        selectedGroupBy: this.selectedGroupBy,
        totalCount: this.groupByTotals.total_count,
        totalUsage: this.groupByTotals.total_usage,
      });
    },

    applyLegacySessionGroupByResponse(response) {
      const legacy = response?.data?.data?.session_group_by;
      if (!legacy || !legacy.sessions) {
        this.sessionDataGroupBy = [];
        this.groupByTotals.total_count = 0;
        this.groupByTotals.total_usage = 0;
        this.total_items = 0;
        this.emitSessionGroupByToParent([]);
        this.$emit("changeTab", {
          total_sessions: 0,
          total_usage: 0,
        });
        return;
      }
      this.groupByTotals.total_count = legacy.total_count || 0;
      this.groupByTotals.total_usage = legacy.total_usage || 0;
      this.sessionDataGroupBy = legacy.sessions;
      this.$emit("changeTab", {
        total_sessions: this.groupByTotals.total_count,
        total_usage: this.groupByTotals.total_usage,
      });
      this.emitSessionGroupByToParent(this.sessionDataGroupBy);
    },

    buildPendingSessionListFilter(search) {
      return {
        start_date: this.filterProp.startDate,
        end_date: this.filterProp.endDate,
        search: search,
        search_by: this.searchBytabs,
        customer_id: this.filterProp.customer_id,
        charger_id: this.filterProp.charger_name == null || this.filterProp.charger_name == "" ? null : this.filterProp.charger_name,
        mp_id: this.filterProp.mp_id ?? null,
      };
    },

    /**
     * Fetches paginated unallocated session table rows and card totals independently.
     * Table endpoint: api/session-log-list-table?page=1&page_size=50
     * Card endpoint: api/session-log-list-card
     */
    async fetchPendingData(page, search, fetchCard = false) {
      let filter = this.buildPendingSessionListFilter(search);
      this.loading = true;
      if (fetchCard) {
        this.fetchPendingCardData({ ...filter });
      }

      const { response, controller } = UserService.GetPendingSessionListTable(filter, page, this.page_size);
      this.sessionController = controller;

      await response
        .then(
          (response) => {
            if(!response.data || !response.data.session_logs){
              this.sessionDataList = [];
              console.log("Unallocated session response is invalid");
              return;
            }
            this.sessionDataList = response.data.session_logs;
            this.current_page = Number(response.data.page || page || 1);
            this.page_size = Number(response.data.page_size || this.page_size);
          },
          (error) => {
            this.loading = false;
            console.log(error.message);
            if (error.code === 'ERR_CANCELED') {
              console.log('Unallocated session data request was cancelled');
              return;
            }
            if (error.response && error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error.message);
        })
        .finally(() => {
          this.loading = false;
          this.sessionController = null;
        });
    },

    async fetchPendingCardData(filter) {
      this.pendingCardRequestId += 1;
      const requestId = this.pendingCardRequestId;
      this.cancelPendingCardRequest();
      this.$emit("cardLoadingChange", true);

      const { response, controller } = UserService.GetPendingSessionListCard(filter);
      this.pendingCardController = controller;

      await response
        .then(
          (response) => {
            if (requestId !== this.pendingCardRequestId) return;
            if (!response.data) {
              this.total.total_sessions = 0;
              this.total.total_usage = 0;
              this.total_items = 0;
              this.$emit("cacheUpdatedAt", "");
              this.$emit("changeTab", this.total);
              console.log("Unallocated session card response is invalid");
              return;
            }
            this.total.total_sessions = response.data.total_sessions || 0;
            this.total.total_usage = response.data.total_usage || 0;
            this.total_items = this.total.total_sessions;
            this.cacheUpdatedAtFromResponse(response);
            this.$emit("changeTab", this.total);
          },
          (error) => {
            if (error.code === 'ERR_CANCELED') {
              console.log('Unallocated session card request was cancelled');
              return;
            }
            console.log(error.message);
            if (error.response && error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        )
        .catch((error) => {
          if (error.code === 'ERR_CANCELED') return;
          console.log(error.message);
        })
        .finally(() => {
          if (requestId === this.pendingCardRequestId) {
            this.$emit("cardLoadingChange", false);
            this.pendingCardController = null;
          }
        });
    },

  /**
   * Fetches session data grouped by a specified criterion from the server based on the current filter settings.
   * The data includes session information filtered by date range, customer ID, charger name, search term, state,
   * and group by criterion. The fetched data is then used to update the component's state and session data list.
   *
   * /////////////////////
   *  Sessions > Group By: By Region, By Charger, By Site
   *
   * By Region:
   *  - endpoint: /api/dashboard-session-group-by
   *  - params: start_date, end_date, group_by=2, kind=1, customer_id, charger_name, search, state
   *
   * By Charger:
   *  - endpoint: /api/dashboard-session-group-by
   *  - params: start_date, end_date, group_by=3, kind=1, customer_id, charger_name, search, state
   *
   * By Site:
   *  - endpoint: /api/dashboard-session-group-by
   * - params: start_date, end_date, group_by=4, kind=1, customer_id, charger_name, search, state
   *
   * /////////////////
   * Unallocated Sessions > Group By: By Region, By Charger, By Site, By Error
   *
   * By Region:
   *  - endpoint: /api/dashboard-session-group-by
   *  - params: start_date, end_date, group_by=2, kind=2, customer_id, charger_name, search, state
   *
   * By Charger:
   *  - endpoint: /api/dashboard-session-group-by
   *  - params: start_date, end_date, group_by=3, kind=2, customer_id, charger_name, search, state
   *
   * By Site:
   *  - endpoint: /api/dashboard-session-group-by
   * - params: start_date, end_date, group_by=4, kind=2, customer_id, charger_name, search, state
   *
   * By Error:
   *  - endpoint: /api/dashboard-session-group-by
   * - params: start_date, end_date, group_by=5, kind=2, customer_id, charger_name, search, state
   *
   */
    async fetchSessionGroupBy(search, fetchCard = true) {
      const filter = this.buildGroupByFilter(search);
      if (fetchCard) {
        this.fetchSessionGroupByCard({ ...filter });
      }
      await this.fetchSessionGroupByTable(search);
    },

    async fetchSessionGroupByCard(filter) {
      this.groupByCardRequestId += 1;
      const requestId = this.groupByCardRequestId;
      this.cancelGroupByCardRequest();
      this.$emit("cardLoadingChange", true);

      const { response, controller } = UserService.DashboardSessionGroupByCard(filter);
      this.groupByCardController = controller;

      await response
        .then(
          (response) => {
            if (requestId !== this.groupByCardRequestId) return;
            const data = response?.data?.data ?? response?.data;
            if (!data || data.total_count == null) {
              this.groupByTotals.total_count = 0;
              this.groupByTotals.total_usage = 0;
              this.total_items = 0;
              this.$emit("cacheUpdatedAt", "");
              this.$emit("changeTab", {
                total_sessions: 0,
                total_usage: 0,
              });
              console.log("Group by card response is invalid");
              return;
            }
            this.groupByTotals.total_count = data.total_count || 0;
            this.groupByTotals.total_usage = data.total_usage || 0;
            this.cacheUpdatedAtFromResponse(response);
            this.$emit("changeTab", {
              total_sessions: this.groupByTotals.total_count,
              total_usage: this.groupByTotals.total_usage,
            });
          },
          async (error) => {
            if (error.code === 'ERR_CANCELED') {
              console.log('Group by card request was cancelled');
              return;
            }
            console.log(error.message);
            if (error.response && error.response.status == 401) {
              this.$router.push({ path: "/" });
              return;
            }
            await this.fetchSessionGroupByLegacy(filter);
          }
        )
        .catch(async (error) => {
          if (error.code === 'ERR_CANCELED') return;
          console.log(error.message);
          await this.fetchSessionGroupByLegacy(filter);
        })
        .finally(() => {
          if (requestId === this.groupByCardRequestId) {
            this.$emit("cardLoadingChange", false);
            this.groupByCardController = null;
          }
        });
    },

    async fetchSessionGroupByTable(search) {
      const filter = this.buildGroupByFilter(search);
      this.loading = true;

      const { response, controller } = UserService.DashboardSessionGroupByTable(filter);
      this.sessionController = controller;

      await response
        .then(
          (response) => {
            const data = response?.data?.data ?? response?.data;
            if (!data || !data.sessions) {
              this.sessionDataGroupBy = [];
              this.$emit("cacheUpdatedAt", "");
              this.emitSessionGroupByToParent([]);
              console.log("Group by table response is invalid");
              return;
            }
            this.sessionDataGroupBy = data.sessions;
            this.cacheUpdatedAtFromResponse(response);
            this.emitSessionGroupByToParent(this.sessionDataGroupBy);
          },
          async (error) => {
            this.loading = false;
            console.log(error.message);
            if (error.code === 'ERR_CANCELED') {
              console.log('Group by table request was cancelled');
              return;
            }
            if (error.response && error.response.status == 401) {
              this.$router.push({ path: "/" });
              return;
            }
            await this.fetchSessionGroupByLegacy(filter);
          }
        )
        .catch(async (error) => {
          this.loading = false;
          if (error.code === 'ERR_CANCELED') return;
          console.log(error.message);
          await this.fetchSessionGroupByLegacy(filter);
        })
        .finally(() => {
          this.loading = false;
          this.sessionController = null;
        });
    },

    async fetchSessionGroupByLegacy(filter) {
      const { response, controller } = UserService.DashboardSessionGroupBy(filter);
      this.sessionController = controller;
      try {
        const result = await response;
        this.applyLegacySessionGroupByResponse(result);
      } catch (error) {
        if (error.code !== 'ERR_CANCELED') {
          console.log(error.message);
          if (error.response && error.response.status == 401) {
            this.$router.push({ path: "/" });
          }
        }
      } finally {
        this.loading = false;
        this.sessionController = null;
      }
    },

    cacheUpdatedAtFromResponse(response) {
      const value = response && response.data && response.data.updated_at;
      this.$emit("cacheUpdatedAt", value || "");
    },

    handleRefresh() {
      this.current_page = 1;
      if (this.selectedGroupBy == "1") {
        if (this.sessionFilter == 1) {
          this.fetchSessionData(this.current_page, this.search, true);
        } else if (this.sessionFilter == 2) {
          this.fetchPendingData(this.current_page, this.search, true);
        }
      } else this.fetchSessionGroupBy(this.search, true);
    },

    handleSelectionChange(item) {
      this.pendingSelectionList = item;
    },

    // used for delete selected rows in table
    async pendingDelete() {
      ElMessageBox.confirm(
        `Are you sure delete ${this.pendingSelectionList.length} rows ?`,
        "confirm",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "Confirm Delete",
        }
      )
        .then(async () => {
          let ids = this.pendingSelectionList.map((item) => item.id);
          let filter = {};
          filter.ids = ids;
          await UserService.sessionLogRemoveBy(filter)
            .then(
              // eslint-disable-next-line no-unused-vars
              (response) => {
                // console.log(response);
                if (ids.length >= 25) {
                  this.handleRefresh();
                } else {
                  this.sessionDataList = this.sessionDataList.filter(
                    (item) => !ids.includes(item.id)
                  );
                }
                useToast().success(
                  "The selected rows have been deleted successfully.",
                  {
                    icon: "fa fa-check",
                    position: "bottom-right",
                    timeout: 2000,
                  }
                );
              },
              (error) => {
                this.loading = false;
                console.log(error.message);
                if (error.response && error.response.status == 401) {
                  this.$router.push({
                    path: "/",
                  });
                }
              }
            )
            .catch((error) => {
              this.loading = false;
              console.log(error.message);
              if (error.response && error.response.status == 401) {
                this.$router.push({
                  path: "/",
                });
              }
            })
            .finally(() => {
              this.loading = false;
              this.sessionController = null; // Clear controller reference
            });
        })
        .catch(() => {
          this.successStep = "error";
          this.removeInvalidRow = false;
        });
    },

    getSessionExportHeader(key, sessionTab, groupBy) {
      if (key === "usage_kWh") return "Usage (kWh)";
      if (key === "abatement_kg") return "Abatement (kg)";
      if (key === "sum_usage") {
        return sessionTab == "3" ? "Sum Usage (MWh)" : "Usage (MWh)";
      }
      if (key === "avg_usage") return "Avg Usage (MWh)";
      if (key === "avg_power") return "Power (kW)";
      if (key === "charger_capacity_kW") return "Charger Capacity (kW)";
      if (key === "count_session") {
        return sessionTab == "3" ? "Count" : "Number of Sessions";
      }
      // Row-list labels that differ from convertToTitleCase(key)
      if (key === "site_title") return "Site Name";
      if (key === "port") return "Port ID";
      if (key === "charger_name") return "Charger ID";
      if (key === "charger_id") return "Charger ID";
      if (key === "register_id") return "Register ID";
      if (key === "elec_region") return "Elec Region";
      if (key === "site_name") return "Site Name";
      // Group-by dimension column labels (match table headers per tab)
      if (key === "group_by") {
        if (groupBy == "2") return "Elec Region";
        if (groupBy == "3") return "Charger ID";
        if (groupBy == "4") return "Site Name";
        if (groupBy == "5") return "Description";
      }
      if (key === "description" && (groupBy == "5" || sessionTab == "3")) {
        return sessionTab == "3" ? "Error / Description" : "Description";
      }
      return key;
    },

    getSessionExportSkipKeys(sessionTab, groupBy) {
      const isGroupBy = groupBy != "1";
      // Row-list exports (All tab)
      if (!isGroupBy) {
        if (sessionTab == "1") {
          // Session - All Sessions
          return [
            "avg_usage",
            "customer_id",
            "state",
            "charger_id",
            "port_id",
            "internal_session_id",
            "project_mp_id",
            "mp_id",
          ];
        }
        if (sessionTab == "2") {
          // Unallocated Session - All Unallocated Sessions
          return ["customer_id", "register_id", "id"];
        }
        return [];
      }
      // Group-by exports: drop IDs / unused fields; keep usage fields with units
      const skip = ["customer_id", "state", "charger_id", "port_id", "id"];
      // Allocated/unallocated group-by tables do not show avg_usage
      if (sessionTab != "3") {
        skip.push("avg_usage");
      }
      // Session group-by uses charger_name / site_name props (not group_by) for charger/site tabs
      if (sessionTab == "1" && (groupBy == "3" || groupBy == "4")) {
        skip.push("group_by");
      }
      // Extra site_name column only shown for session By Charger; keep it.
      // For By Site, site_name is the dimension — do not skip.
      return skip;
    },

    async downloadChargersXlsx(dataList) {
      try {
        // console.log("tableData", dataList);
        const sessionTab = this.sessionFilter;
        const groupBy = this.selectedGroupBy;

        let mainTitle = sessionTab == 1 ? "Session" : "Unallocated Session";
        let selectedTableTab = sessionTab == 1 ?
        groupBy == 1 ? "All Sessions" : groupBy == 2 ? "By Region" : groupBy == 3 ? "By Charger" : groupBy == 4 ? "By Site" : "By Error"
        : groupBy == 1 ? "All Unallocated Sessions" : groupBy == 2 ? "By Region" : groupBy == 3 ? "By Charger" : groupBy == 4 ? "By Site" : "By Error";

        const skipKeys = this.getSessionExportSkipKeys(sessionTab, groupBy);

        // Rename keys so Excel headers match table labels (with units) for each tab
        const exportDataList = dataList.map((row) => {
          const mapped = {};
          Object.keys(row).forEach((key) => {
            if (skipKeys.includes(key)) return;
            mapped[this.getSessionExportHeader(key, sessionTab, groupBy)] = row[key];
          });
          return mapped;
        });

        const fileName = `${mainTitle}_${selectedTableTab}.xlsx`; // File name
        const newWorksheetName = `${selectedTableTab}`; // Worksheet name
        const title = `${mainTitle} - ${selectedTableTab}`; // Title for the Excel file

        // console.log(fileName, newWorksheetName, title, skipKeys);

        await exportToExcel({
          dataList: exportDataList,
          skipKeys: [],
          fileName,
          newWorksheetName,
          title,
        });

      } catch (error) {
        console.error("error when download file", error.message);
      }
    },

    handleDownloadCommand(command) {
      switch (command) {
        case 'default':
          this.handleExportFile('default');
          break;
        case 'currentMP':
          this.handleExportFile('currentMP');
          break;
        case 'recent':
          this.handleExportFile('recent');
          break;
      }
    },

    async handleExportFile(download_command = 'default') {
      // TODO: Handle different export types based on 'type' parameter
      // type can be: 'default', 'currentMP', or 'recent'
      console.log("Export type selected:", download_command);
      
      if (this.selectedGroupBy == "1") {
        if (this.sessionFilter == 1) {
          await this.fetchAllSessionData(this.current_page, this.perPageCount);

        } else if (this.sessionFilter == 2) {
          const result = await this.fetchAllPendingData(this.current_page, this.perPageCount, download_command);
          console.log("hasCustomerFilter", this.hasCustomerFilter);
          console.log("result", this.current_page, this.perPageCount, download_command);
          if(result == false){
            console.log("Excel data not found, cannot download data for excel");
            return;
          }
        }
      } else {
        this.excelDataList = Array.isArray(this.sessionDataGroupBy) ? this.sessionDataGroupBy : [];
      }

      if (this.excelDataList && Array.isArray(this.excelDataList) && this.excelDataList.length > 0) {
        this.downloadChargersXlsx(this.excelDataList);
      } else {
        console.log("received empty datalist when fetching data for excel");
        return;
      }
    },

    // fetch all sessions data for export excel
    async fetchAllSessionData() {
      // for Sessions All, no need to fetch data without pagination due to data size
      // just use data for current page
      this.excelDataList = Array.isArray(this.sessionDataList) ? this.sessionDataList : [];
    },

    async fetchAllPendingData(page, pageSize, download_command = 'default') {
        let filter = {
          start_date: this.filterProp.startDate,
          end_date: this.filterProp.endDate,
          search: "",
          search_by: this.searchBytabs,
          customer_id: this.filterProp.customer_id,
          charger_id: this.filterProp.charger_name == null || this.filterProp.charger_name == "" ? null : this.filterProp.charger_name,
          download_command: download_command || "default",
        };

        console.log("filter", filter);

        // check if customer filter is applied before fetching data
        
        
        if (!filter.customer_id || filter.customer_id == null || filter.customer_id == "") {
          if (!this.$store.state.auth.user.is_admin && this.$store.state.auth.user.is_active) {
            this.hasCustomerFilter = true;
          } else {
            this.hasCustomerFilter = false;
            console.log("customer filter is not applied, cannot bypass pagination for unallocated sessions export");
            this.$message.error("Customer filter is not applied, please apply customer filter to export data");
            this.loading = false;
            return false;
          }
        }

        this.hasCustomerFilter = true;

        try {
          console.log("pagesize", pageSize);

          // pagesize 0 means bypass pagination
          // this is a celery task, so we need to poll the task status
          // send request to get task id and start polling
          const response = await UserService.GetPendingSessionListTable(filter, page, 0).response;

          if (!response.data || !response.data.task_id) {
            console.log("Invalid response structure, task_id is not found in response");
            return false;
          }

          const taskId = response.data.task_id;
          let groupBy = this.selectedGroupBy;
          let sessionTab = this.sessionFilter;
          let selectedTableTab = sessionTab == 1 ?
              groupBy == 1 ? "All Sessions" : groupBy == 2 ? "By Region" : groupBy == 3 ? "By Charger" : groupBy == 4 ? "By Site" : "By Error"
              : groupBy == 1 ? "All Unallocated Sessions" : groupBy == 2 ? "By Region" : groupBy == 3 ? "By Charger" : groupBy == 4 ? "By Site" : "By Error";

              // add task to session storage
          addTaskIdtoSessionStorage('session', taskId, 'PENDING', 'exportToExcel', {
            skipKeys: [],
            fileName: `Unallocated Session_${selectedTableTab}.xlsx`,
            newWorksheetName: `${selectedTableTab}`,
            title: `Unallocated Session_${selectedTableTab}`,
          });
          
          // msg user
          this.$message.success("Task started, please wait for task to complete");

          // create poller
          const poller = createCeleryTaskPoller(response.data.task_id, 15000, 'session');
          this.sessionPoller = poller;

          // start polling
          poller.startPolling();

          
        } catch (error) {
          this.loading = false;
          console.log(error.message);
          if (error.response && error.response.status === 401) {
            this.$router.push({
              path: "/",
            });
          }
          return false;
        }
      },
  },

  beforeUnmount() {
      // Cancel any ongoing session data request
      this.cancelSessionRequest();
      // Stop poller if it's still active
      console.log("Stopping session poller in beforeUnmount");


    },

};
</script>